import React from 'react';
import './offersBySupplier.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup, statusOffertaProgress, acquisizioneOptions} from '../../globals';
//import { useAuth } from  '../../contexts/auth'; 

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  //Pager,
  //Paging,
  //FilterRow,
  HeaderFilter,
  Format,
  Lookup,
  Editing,
  Selection,
  Toolbar,
  Item,
  Summary,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect} from "react";
//import { Toolbar, Item } from 'devextreme-react';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_OfferteByFornitore'

const debug = process.env.ENTITY_DEBUG;


export default function OffersBySupplier(props) {

  const [stati, setStati] = useState({});
  // const [clienti, setClienti] = useState({});
  // const [collaboratori, setCollaboratori] = useState({});
  // const [concorrenti, setConcorrenti] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [fornitori, setFornitori] = useState({});
  // const [tipiSoggetto, setTipiSoggetto] = useState({});
  // const [tipiOfferta, setTipiOfferta] = useState({});
  // const [categorieOfferta, setCategorieOfferta] = useState({});
  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(new Date().getFullYear());
  const [intermediarioFilter, setIntermediarioFilter] = useState(210);
  const [fornitoreFilter, setFornitoreFilter] = useState();
  const [statoFilter, setStatoFilter] = useState();
  const [rifOffertaFilter, setRifOffertaFilter] = useState();
  // const [managerFilter, setManagerFilter] = useState();
  // const [tipoFilter, setTipoFilter] = useState();
  // const [prioritaFilter, setPrioritaFilter] = useState();
  // const [categoriaFilter, setCategoriaFilter] = useState();

  const filterPayload = { 
    //storico: isStorico,
    anno: annoFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    fornitore: fornitoreFilter,
    rifOfferta: rifOffertaFilter
  };

  const user = useCheckUserAuthentication();

  const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/Find',
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
          var payload = ajaxOptions.data;
          payload.values = JSON.stringify(filterPayload);
          ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },

    errorHandler: (error) => {
      handleAuthError(error);
    }

  });

  useEffect(() => {

    const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OffertaStato';
    var newUrl =  newServiceUrl + "/GetAction";

    const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

    const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniOfferte';
    var newUrl9 =  newServiceUrl9 + "/GetAction";

    const newServiceUrl14 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl14 =  newServiceUrl14 + "/GetFornitori";

    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        const json7 = await fetchLookup(newUrl7,requestOptions);
        if (json7) {
          setIntermediari(json7);
        }
        // const response7 = await fetch(newUrl7,requestOptions);
        // const json7 = await response7.json();
        // if (debug === 1)
        //   console.log(json7);
        // setIntermediari(json7);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

        const json14 = await fetchLookup(newUrl14,requestOptions);
        if (json14) {
          setFornitori(json14);
        }
        // const response14 = await fetch(newUrl14,requestOptions);
        // const json14 = await response14.json();
        // if (debug === 1)
        //   console.log(json14);
        // setFornitori(json14);

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
  }, [user?.token]); // Aggiorna se il token cambia

  function customizeText(data) {
    return `Offerte: ${data.value}`;
  }

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
  };
  
  const selectBoxOptions2 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };
  
  const selectBoxOptions3 = {
    width: 180,
    items: stati,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Stato>",
    showClearButton:true,
    onValueChanged: (args) => {
      setStatoFilter(args.value);
    },
    value: statoFilter
  };

  const selectBoxOptions8 = {
    width: 210,
    items: fornitori,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Fornitore>",
    showClearButton:true,
    searchEnabled:true,
    onValueChanged: (args) => {
      setFornitoreFilter(args.value);
    },
    value: fornitoreFilter,
  };

  const textBoxOptions2 = {
    width: 200,
    placeholder:"<Rif. Offerta Fornitore>",
    onValueChanged: (args) => {
      setRifOffertaFilter(args.value);
    },
    value: rifOffertaFilter
  };

  // const selectBoxOptions4 = {
  //   width: 180,
  //   items: collaboratori,
  //   valueExpr: 'id',
  //   displayExpr: 'cognome',
  //   placeholder:"<Manager/Deputy>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setManagerFilter(args.value);
  //   },
  //   value: managerFilter
  // };

  // const selectBoxOptions5 = {
  //   width: 150,
  //   items: tipiOfferta,
  //   valueExpr: 'id',
  //   displayExpr: 'nome',
  //   placeholder:"<Tipo>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setTipoFilter(args.value);
  //   },
  //   value: tipoFilter,
  // };

  // const selectBoxOptions6 = {
  //   width: 150,
  //   items: prioritaOptions,
  //   valueExpr: 'id',
  //   displayExpr: 'desc',
  //   placeholder:"<Priorità>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setPrioritaFilter(args.value);
  //   },
  //   value: prioritaFilter,
  // };

  // const selectBoxOptions7 = {
  //   width: 150,
  //   items: categorieOfferta,
  //   valueExpr: 'id',
  //   displayExpr: 'nome',
  //   placeholder:"<Categoria>",
  //   showClearButton:true,
  //   onValueChanged: (args) => {
  //     setCategoriaFilter(args.value);
  //   },
  //   value: categoriaFilter,
  // };

  function onToolbarPreparing(e) {
   
    e.toolbarOptions.items.push({
      widget: 'dxButton',
      name: "myexport",
      location: "before",
      options: {
          icon: "exportxlsx",
          hint: "Esporta in Excel",
          onClick: function() {
            onExporting(e);
          }
      }
    });

  }
  
  function onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Offerte per Fornitore');
  
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Offerte_x_Fornitore.xlsx');
      });
    });
    e.cancel = true;
  }

return (
  <React.Fragment>
    <h2 className={'content-block'}>Offerte per Fornitore</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          columnHidingEnabled={true}
          showBorders={true}
          onExporting={onExporting}
          onToolbarPreparing = {onToolbarPreparing}
          onCellPrepared={statusOffertaProgress}
        >
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Toolbar>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions8} >
            </Item>
           
           <Item location="after"
              locateInMenu="auto"
              widget="dxTextBox"
              options={textBoxOptions2} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions3} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>

         </Toolbar>
         <HeaderFilter visible={true} />
          <Summary>
            <TotalItem
                column="oggetto"
                summaryType="count"
                customizeText={customizeText}
            />
          </Summary>
        <Selection mode="single" />
        <Editing
          mode="row"
          useIcons={true}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}     
        />
        <Column dataField="id" visible={false}/>
        <Column dataField="numeroDoc" caption="Numero" width={80}/>
        <Column dataField="dataDoc" dataType="date" format= {'dd/MM/yyyy'} caption="Data" width={110} />
        <Column dataField="oggetto" caption="Progetto" width={360}/>
        <Column dataField="intermediarioId" caption="Azienda"  visible={false}>
          <Lookup dataSource={intermediari} valueExpr="id" displayExpr="alias" />
        </Column>
   
        <Column dataField="cliente" />
        <Column dataField="fornitore" />
 
    

        <Column dataField="rifOffertaFornitore" caption="Rif. Offerta Forn."/>
        <Column dataField="percAcquisizione" caption="Prob. acquisizione" visible={true} width={200}>
          <Lookup dataSource={acquisizioneOptions} displayExpr="desc" valueExpr="id" />
        </Column>
         <Column dataField="importoAcquisizione"  caption="Imp. acquisizione" width={160}>
          <Format type="fixedPoint" precision={2} /> 
        </Column>
        <Column dataField="imponibile"  width={160}>
          <Format type="fixedPoint" precision={2} /> 
        </Column>

        <Column dataField="importoTotale"  width={140} caption="Importo">
          <Format type="fixedPoint" precision={2} />
        </Column>
        
        <Column dataField="statoId" caption="Stato" width={110}>
          <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
        </Column>
      </DataGrid>  
      </div>
    </div>
  </React.Fragment>
)};
